import { render, staticRenderFns } from "./LalamoveMissing.vue?vue&type=template&id=612e5c1a&scoped=true"
import script from "./LalamoveMissing.vue?vue&type=script&lang=js"
export * from "./LalamoveMissing.vue?vue&type=script&lang=js"
import style0 from "./LalamoveMissing.vue?vue&type=style&index=0&id=612e5c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e5c1a",
  null
  
)

export default component.exports